import { render, staticRenderFns } from "./TrsBudgetAlteration.vue?vue&type=template&id=13c1ccbc&scoped=true"
import script from "./TrsBudgetAlteration.vue?vue&type=script&lang=js"
export * from "./TrsBudgetAlteration.vue?vue&type=script&lang=js"
import style0 from "./TrsBudgetAlteration.vue?vue&type=style&index=0&id=13c1ccbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c1ccbc",
  null
  
)

export default component.exports